/**
 * True when value looks like a TipTap/ProseMirror document (type: 'doc').
 * Empty mongoose defaults ({}) and plain objects without type are rejected.
 */
export default function isTipTapDoc(value: unknown): boolean {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return false
  }

  const doc = value as { type?: unknown; content?: unknown }
  return doc.type === 'doc' && Array.isArray(doc.content)
}
